import React, { Component } from 'react';
import ModalDialog from 'react-bootstrap/lib/ModalDialog';
import Draggable from 'react-draggable';

class DraggableModal extends Component {
  render() {
    return <Draggable handle=".draggable-modal" enableUserSelectHack={false}><ModalDialog {...this.props} /></Draggable>;
  }
}

export default DraggableModal;



// WEBPACK FOOTER //
// ./src/js/Components/Elements/DraggableModal.js